import { Calendar } from '../calendar/entity'
import { CallRecord } from '../call-record/entity'
import { CurrentSettlementRecord } from '../current-settlement-record/entity'
import { DeliveryRecord } from '../delivery-record/entity'
import { ElectronicPrescription } from '../electronic-prescription/entity'
import { PharmacyVisitStatus } from '../enums/pharmacy-visit-status'
import {
  InsuranceRegistration,
  OnlineVerificationRegisteredType,
} from '../insurance-registration/entity'
import { Patient } from '../patient/entity'
import { PharmacyVisitAttachment } from '../pharmacy-visit-attachment/entity'
import { Pharmacy } from '../pharmacy/entity'
import { PrescriptionImage } from '../prescription-image/entity'
import { PrescriptionNotebookImage } from '../prescription-notebook-image/entity'
import { QuestionnaireAnswer } from '../questionnaire-answer/entity'
import { ReservationCandidate } from '../reservation-candidate/entity'
import { SettlementRecord } from '../settlement-record/entity'
import { TwilioMessage } from '../twilio-message/entity'

export type PharmacyVisit = {
  uid: string
  doctorVisitUid: string
  patient: Patient | null
  pharmacyUid: string
  applicationType: ApplicationType
  status: PharmacyVisitStatus
  callRecords: CallRecord[]
  settlementRecords: SettlementRecord[]
  currentSettlementRecord: CurrentSettlementRecord | null
  deliveryRecord?: DeliveryRecord
  twilioMessages: TwilioMessage[]
  comment: string | null

  latestInsuranceRegistration: InsuranceRegistration | null
  doctorVisitInsuranceVerificationType: OnlineVerificationRegisteredType | null

  visitedAt: string | null
  completedAt: string | null
  createdAt: string
  stripePaymentMethodId: string | null
  reservedCalendar: Calendar | null
  reservedFrameUid: string | null
  reservationStartedAt: string | null
  reservationFinishedAt: string | null
  prescriptionNotebookImages: PrescriptionNotebookImage[]
  prescriptionImages: PrescriptionImage[]
  questionnaireAnswer: QuestionnaireAnswer | null
  electronicPrescription: ElectronicPrescription | null
  reservationCandidates: ReservationCandidate[] // リクエスト予約廃止に伴い空配列となる
  placeToReceiveService: PlaceToReceiveService | null
  medicineDispensedAt: string | null
  medicinePassedAt: string | null
  medicineReceiveAppliedAt: string | null
  fromCuron: boolean
  fromMomo: boolean
  pharmacy: Pharmacy
  attachments: PharmacyVisitAttachment[]
  message: string | null
  applicationCompletedAt: string | null // 服薬指導予約完了 or 薬局受け取り予約完了
  recentlyVisited: boolean | null
  canceledAt: string | null
  completedBy: CompletedBy | null
  usageNumber: string | null
  pickupRequestedAt: string | null // 患者の受け取り希望時間
  dispenseCompletionAt: string | null // 薬局の調剤完了予定時間
}

export enum PlaceToReceiveService {
  InHome = 'in_home',
  InStore = 'in_store',
}

export enum ApplicationType {
  NetReception = 'net_reception',
  Pharmacy = 'pharmacy',
  Curon = 'curon',
  Momo = 'momo',
  CuronByCuronConnect = 'curon_by_curon_connect',
  NetReceptionByCuronConnect = 'net_reception_by_curon_connect',
}

export enum CompletedBy {
  Pharmacy = 'pharmacy',
  BatchJob = 'batch_job',
}
